import Base, {
  axios,
  setPromise,
  getEndpoint,
} from './base'

export {
  APIURI,
  client_secret,
  client_id,
  getFirstErrorMessage,
  getErrorMessage,
  getErrorMessages,
  getErrorMessagesWithKeys,
  endpoints,
  services,
  handlePromise,
  promise,
  setPromise,
  getEndpoint,
} from './base'

export const checkCouponDiscount = async (payload, options = {}) => {
  const endPoint = getEndpoint('cart.discounts.coupon.check', {}, '/customer/coupon/check', options)
  const {data} = await axios.post(endPoint, payload)
  data.type = 'coupon'
  return data
}
setPromise('cart.discounts.coupon.check', checkCouponDiscount)

const myServices = {checkCouponDiscount}

export default {
  ...Base,
  ...myServices
}
